<template>
  <div>
    <div v-if="position === 1">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="position === 2">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="position === 3">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="position === 4">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="position === 5">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="position === 6">
      <div v-if="infoVisible === 'contact'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('contact')"
              class="text-lg cursor-pointer px-12 hover:text-black"
            >
              Contact
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  >I am based in Badalona, Barcelona. If you have any questions,
                  want to collaborate, or simply start a conversation, do not
                  hesitate to get in touch with me:
                  nurianusan@gmail.com</RandomText
                >
              </li>
            </ul>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'approaches'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('approaches')"
              class="text-lg cursor-pointer px-12"
            >
              Skills
            </RandomText>
            <ul class="px-20">
              <li>
                <RandomText
                  @click="approachesShow('sustainability')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'sustainability'
                      ? 'text-gray-400'
                      : '',
                  ]"
                >
                  Software
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="approachesShow('pitching')"
                  :class="[
                    'text-lg',
                    'cursor-pointer',
                    'hover:text-black',
                    approachesVisible !== 'pitching' ? 'text-gray-400' : '',
                  ]"
                >
                  Web Development
                </RandomText>
              </li>
            </ul>
            <div class="pt-4">
              <div v-if="approachesVisible === 'sustainability'">
                <div class="flex flex-wrap">
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Figma.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Figma</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_XD_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>XD</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/adobe-photoshop-logo-2.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Photoshop</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Illustrator</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>InDesign</p>
                  </div>
                  <div class="justify-items-center p-4">
                    <img
                      src="../../public/img/Final_Cut_Pro_iPad.webp"
                      alt=""
                      class="w-14 h-14"
                      loading="lazy"
                    />
                    <p>Final Cut</p>
                  </div>
                </div>
              </div>
              <div
                v-if="approachesVisible === 'pitching'"
                class="w-full flex flex-col gap-4"
              >
                <p class="text-md underline">lenguagesProgramming</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">HTML</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">CSS</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">JS</p>
                  </div>
                </div>
                <p class="text-md underline">frames</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">Vue.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle trenta">
                      <span>35%</span>
                    </div>
                    <p class="text-sm">Svelte.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Node.js</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle vint">
                      <span>25%</span>
                    </div>
                    <p class="text-sm">Socket.io</p>
                  </div>
                </div>
                <p class="text-md underline">eines</p>
                <div class="flex flex-wrap gap-6 px-4">
                  <div class="flex flex-col items-center">
                    <div class="circle sis">
                      <span>65%</span>
                    </div>
                    <p class="text-sm">Boostrap</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle setanta">
                      <span>75%</span>
                    </div>
                    <p class="text-sm">Tailwind</p>
                  </div>
                  <div class="flex flex-col items-center">
                    <div class="circle cinc">
                      <span>50%</span>
                    </div>
                    <p class="text-sm">GSAP</p>
                  </div>
                </div>
                <div class="flex">
                  <div class="">
                    <p class="text-md underline">base</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle quatre">
                          <span>40%</span>
                        </div>
                        <p class="text-sm">MongoDB</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-md underline">CMS</p>
                    <div class="flex p-4">
                      <div class="flex flex-col items-center">
                        <div class="circle sis">
                          <span>65%</span>
                        </div>
                        <p class="text-sm">Wordpress</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'people'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('people')"
              class="text-lg cursor-pointer px-12"
            >
              About me
            </RandomText>
            <div class="pt-4">
              <RandomText v-if="studioVisible === 'studio'" class="text-base">
                I am Núria Jordán, a student of Audiovisual and Multimedia
                Communication. I am 21 years old, and over these four years of
                studies, I have learned various skills such as web programming,
                graphic design, photography and video, and a bit of 3D. I
                consider myself an outgoing, energetic person with effective
                communication skills. I have experience working in teams and
                collaborating on projects to achieve goals efficiently. I am
                committed to continuing to develop my skills and keep learning.
              </RandomText>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('practice')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Experience
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-if="infoVisible === 'practice'">
        <ul>
          <li>
            <RandomText
              @click="changeInfo('practice')"
              class="text-lg cursor-pointer px-12"
            >
              Experience
            </RandomText>
            <div class="pt-4">
              <div class="pt-4 w-full" v-if="practiceVisible === 'scena'">
                <div>
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      Web Developer - Units x Educar
                    </p>
                    <p class="text-sm md:text-base">june 2024</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exUnits</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">prBroomx</p>
                    <p class="text-sm md:text-base">
                      february 2024 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exBroomx</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      membre Playful Living Lab
                    </p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exLab</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">coCreator Wildtech</p>
                    <p class="text-sm md:text-base">
                      september 2023 - june 2024
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exWildtech</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      coCreator Mural “El Modern”
                    </p>
                    <p class="text-sm md:text-base">
                      january 2023 - march 2023
                    </p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exModern</p>
                </div>
                <div class="pt-4 md:pt-2">
                  <div class="md:flex justify-between">
                    <p class="text-sm md:text-base">
                      profesora Workshop Wordpress
                    </p>
                    <p class="text-sm md:text-base">january 2023</p>
                  </div>
                  <p class="text-xs md:text-sm text-zinc-500">exEram</p>
                </div>
              </div>
            </div>
          </li>
          <li class="pt-10 px-12">
            <ul>
              <li>
                <RandomText
                  @click="changeInfo('people')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  About me
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('approaches')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Skills
                </RandomText>
              </li>
              <li>
                <RandomText
                  @click="changeInfo('contact')"
                  class="text-lg cursor-pointer text-gray-400 hover:text-black"
                >
                  Contact
                </RandomText>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RandomText from "@/components/RandomText.vue";
export default {
  components: {
    RandomText,
  },

  data() {
    return {
      isVisible: false,
      infoVisible: "contact",
      studioVisible: "studio",
      practiceVisible: "scena",
      approachesVisible: "sustainability",
      position: 1,
    };
  },
  methods: {
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    changeInfo(newValue) {
      this.infoVisible = newValue;
      //console.log(this.infoVisible);
    },
    peopleShow(newValue) {
      this.studioVisible = newValue;
      //console.log(this.studioVisible);
    },
    practiceShow(newValue) {
      this.practiceVisible = newValue;
      //console.log(this.studioVisible);
    },
    approachesShow(newValue) {
      this.approachesVisible = newValue;
      //console.log(this.approachesVisible);
    },
    generateRandomNumber() {
      this.position = Math.floor(Math.random() * 6) + 1;
    },
  },
  mounted() {
    this.generateRandomNumber();
  },
};
</script>

<style>
.circle {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.setanta {
  background: conic-gradient(#fff 0deg 270deg, #000 270deg 360deg);
}

.sis {
  background: conic-gradient(#fff 0deg 210deg, #000 210deg 360deg);
}

.cinc {
  background: conic-gradient(#fff 0deg 180deg, #000 180deg 360deg);
}

.quatre {
  background: conic-gradient(#fff 0deg 150deg, #000 150deg 360deg);
}

.trenta {
  background: conic-gradient(#fff 0deg 100deg, #000 100deg 360deg);
}

.vint {
  background: conic-gradient(#fff 0deg 80deg, #000 80deg 360deg);
}

.circle::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  background: var(--background-color);
  border-radius: 50%;
}

.circle span {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: var(--text-color);
}

.text-submenu {
  color: var(--subtext-color);
}

.text-submenu:hover {
  color: var(--text-color);
}

.text-color {
  color: var(--text-color);
}
</style>